<template>
    <LandingPageLayout
        v-bind="landingPageSharedData.getLandingPageLayoutProps()"
    >
        <article class="max-w-4xl mx-auto py-4 px-6 lg:px-0 flex-1">
            <div class="space-y-8 mb-20">
                <header>
                    <h1 class="text-3xl font-semibold">Zoom Tutorial</h1>
                </header>

                <section
                    class="space-y-4"
                    aria-label="Zoom integration overview"
                >
                    <p>
                        Connect TinyCal and Zoom to generate meeting links for
                        each meeting scheduled.
                    </p>
                    <p>
                        Invitees will receive location details in the
                        confirmation notification after scheduling with you.
                    </p>
                    <p>
                        The unique link will appear in your confirmation email,
                        booking details of your dashboard and on the Google
                        Calendar event.
                    </p>
                </section>

                <section
                    class="space-y-4"
                    aria-labelledby="zoom-connect-heading"
                >
                    <h2
                        id="zoom-connect-heading"
                        class="text-xl font-semibold"
                    >
                        How to connect
                    </h2>
                    <p>
                        Log in into your dashboard, access the "Integrations"
                        page from the left sidebar, then click "Connect" button
                        in the top right corner, a drawer will open, select the
                        Zoom integration and click the button "Connect" at the
                        bottom right corner of the page.
                    </p>
                    <p>
                        You will get redirected to Zoom's authorization page,
                        once you authorize our access to your account, you will
                        be redirected back to TinyCal and your Zoom account
                        should be connected and ready to go.
                    </p>
                    <p>
                        Once your Zoom account is connected, update the desired
                        service you want to automatically generate Zoom meeting
                        links for and select Zoom as one of the available
                        location options.
                    </p>
                    <p>
                        And with that you should be all set. Don't hesitate to
                        reach out to us in case you have problems, we are glad
                        to help.
                    </p>
                </section>

                <section
                    class="space-y-4"
                    aria-labelledby="zoom-disconnect-heading"
                >
                    <h2
                        id="zoom-disconnect-heading"
                        class="text-xl font-semibold"
                    >
                        How to disconnect
                    </h2>
                    <p>
                        Log into your TinyCal account, access the "Integrations"
                        page from the left sidebar, in it you should see your
                        Zoom integration listed, click the red delete button,
                        once done we will no longer have access to your Zoom
                        account.
                    </p>
                    <p>
                        Remember that if you delete your Zoom integration we
                        will not be able to automatically generate Zoom meeting
                        links for your meetings.
                    </p>
                </section>
            </div>
        </article>
    </LandingPageLayout>
</template>

<script setup lang="ts">
    import LandingPageLayout from '@/Marketing/LandingPage/Shared/LandingPageLayout.vue'
    import LandingPageSharedData from '@/Marketing/LandingPage/Entity/LandingPageSharedData'

    interface LandingPageProps {
        landingPageSharedDataRawData: any
    }

    const props = defineProps<LandingPageProps>()
    const landingPageSharedData = LandingPageSharedData.hydrate(
        props.landingPageSharedDataRawData,
    )
</script>
